// ##############################
// // // Consultation view styles
// #############################

import fonts from "~/shared/styles/fonts.css";

import * as MDPro from "../../material-dashboard/assets/jss/material-dashboard-pro-react.jsx";
import * as Base from "~/shared/styles/baseStyles.js";

// add in custom styling included in material dashboard pro
import customCheckboxRadioSwitch from "../../material-dashboard/assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import selectStyles from "../../material-dashboard/assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";

import {
  kickRed,
  kickNavy,
  kickLightBlue,
  kickBlue,
  kickAmaOrange,
} from "~/shared/styles/baseStyles.js";

export const VISIT_MAX_WIDTH = "800px";

const consultationStyle = (theme) => ({
  ...customCheckboxRadioSwitch,
  ...selectStyles,
  cardTitle: {
    ...MDPro.cardTitle,
    fontFamily: "Spectral-Bold",
    marginBottom: 0,
    lineHeight: "1.25",
    [theme.breakpoints.down("md")]: { fontSize: "30px" },
    color: kickBlue,
  },
  cardSubtitle: {
    ...MDPro.cardSubtitle,
  },
  containerWithSpacing: {
    borderTop: "1px solid #ddd",
    paddingTop: "20px",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    "& > div": {
      width: "100vw",
      margin: "0",
    },
    [theme.breakpoints.down("md")]: {
      paddingTop: "0",
    },
  },
  container: {
    position: "relative",
    zIndex: "3",
  },
  cardSignup: {
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
    marginBottom: "100px",
    marginTop: "30px",
    padding: "0px 0px 40px",
    [theme.breakpoints.up("sm")]: {
      paddingTop: "20px",
    },
  },
  signupButton: {
    marginTop: "6px",
    width: "100%",
    maxWidth: "300px",
    backgroundColor: kickAmaOrange,
    color: kickNavy,
    fontSize: "18px",
    fontWeight: "medium",
    textTransform: "unset",
  },
  center: {
    textAlign: "center",
  },
  right: {
    textAlign: "right",
  },
  left: {
    textAlign: "left",
  },
  form: {
    position: "relative",
  },
  socialTitle: {
    fontSize: "18px",
  },
  inputAdornment: {
    marginRight: "18px",
    position: "relative",
  },
  inputAdornmentIcon: {
    color: "#555",
  },
  customFormControlClasses: {
    margin: "0 12px",
  },
  checkboxLabelControl: {
    margin: "0",
  },
  checkboxLabel: {
    marginLeft: "6px",
    fontFamily: "BasisGrotesquePro-Regular",
    fontSize: "16px",
    lineHeight: "22px",
    color: "#1E2347",
  },
  radioLabel: {
    marginLeft: "6px",
    fontFamily: "BasisGrotesquePro-Regular",
    fontSize: "16px",
    lineHeight: "22px",
    color: "#1E2347",
  },

  signupSubHeading: {
    textAlign: "center",
    color: kickNavy,

    padding: "0 80px",

    [theme.breakpoints.down("md")]: { padding: "0" },
  },

  signupComingSoonTitle: {
    alignSelf: "center",
    textAlign: "center",
    margin: "40px auto",
    [theme.breakpoints.up("xs")]: {
      alignItems: "center",
    },
    [theme.breakpoints.up("sm")]: { width: "50%" },
  },

  selectBBProductWrapper: {
    "& > img": {
      width: "426px",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "30px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      "& > img": {
        maxWidth: "100%",
        left: "20px",
      },
      "& > .imgTwoPack": {
        left: "50px",
      },
    },
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      paddingLeft: "80px",
      paddingTop: "40px",
      paddingBottom: "30px",
      "& > img": {
        maxWidth: "50%",
      },
    },
  },

  selectBBProductTwoPackWrapper: {
    justifyContent: "left",

    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      justifyContent: "center",
      fontSize: "16px",
    },

    [theme.breakpoints.up("md")]: {
      marginLeft: "-40px",
      paddingRight: "10px",
    },

    "& ul": {
      textAlign: "left",
      [theme.breakpoints.up("md")]: {
        marginLeft: "-30px",
      },
    },
  },
  selectBBProductImageTitle: {
    textAlign: "left",
    fontSize: "20px",

    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      marginTop: "10px",
      marginLeft: 0,
    },
    [theme.breakpoints.up("md")]: {
      alignSelf: "center",
      bottom: "100px",
    },
  },
  selectBBProductImageTitleLower: {
    textAlign: "left",
    fontSize: "20px",

    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      marginTop: "10px",
      marginLeft: 0,
    },
    [theme.breakpoints.up("md")]: {
      alignSelf: "center",
      bottom: "100px",
      marginLeft: "-40px",
      paddingRight: "10px",
    },
  },

  // Select Sleep Product Page
  selectSleepProductPlansWrapper: {
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flexDirection: "row",
    },
  },
  selectSleepProductWrapper: {
    [theme.breakpoints.up("xs")]: {
      padding: "30px",
    },
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flexDirection: "row",
      paddingLeft: "80px",
      paddingTop: "40px",
      paddingBottom: "30px",
    },
  },
  selectSleepProductButton: {
    display: "block",
    backgroundColor: "#F25930",
    margin: "4px auto 30px auto",
    width: "200px",
    fontSize: "15px",
    fontWeight: "medium",
    textTransform: "unset",
  },

  // Payment page
  paymentCardBody: {
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column-reverse",
      padding: "0 2px",
    },
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flexDirection: "row",
      padding: "0 2px",
    },
  },
  paymentForm: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    maxWidth: VISIT_MAX_WIDTH,
    marginBottom: "24px",

    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
    },
  },
  paymentHeading: {
    fontSize: "16px",
    fontFamily: "BasisGrotesquePro-Regular",
    marginBottom: "12px",
    paddingTop: "2px",
    fontWeight: "bold",
  },
  paymentHeadingDiscount: {
    color: "#f25930",
  },
  paymentShippingAddressHeading: {
    fontSize: "20px",
    fontFamily: "Spectral",
    marginBottom: "20px",

    [theme.breakpoints.up("md")]: {
      margin: "20px 0",
    },
    [theme.breakpoints.down("sm")]: {
      alignSelf: "flex-start",
      marginTop: "20px",
      marginBottom: "0px",
    },
  },
  confirmAndPayButton: {
    display: "block",
    backgroundColor: "#F25930",
    margin: "40px auto 10px",
    minWidth: "300px",
    borderRadius: "4px",
    fontFamily: "BasisGrotesquePro-Regular",
    textTransform: "none",
    fontSize: "14px",
  },
  stripePaymentRequestButtonBlock: {
    width: "300px",
    margin: "0 auto 40px",
    display: "flex",
    flexDirection: "column",
  },
  paymentTotal: {
    fontSize: "22px",
    fontWeight: "bold",
    marginTop: "8px",
  },
  paymentOrderSummary: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    alignItems: "center",

    [theme.breakpoints.down("sm")]: {
      paddingTop: "10px",
      paddingBottom: "10px",
    },
  },
  paymentOrderSummaryImageBetaBlockers: {
    marginTop: "30px",
    marginLeft: "130px",
  },
  paymentOrderSummaryImageSleep: {
    display: "none",

    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  paymentOrderSummarySection: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
  },
  paymentOrderSummaryTitles: {
    display: "flex",
    flexDirection: "column",

    [theme.breakpoints.up("md")]: {
      display: "flex",
      alignItems: "flex-start",
    },
  },
  paymentOrderSummaryPrices: {
    display: "flex",
    flexDirection: "column",
    textAlign: "right",
  },
  paymentGroupPaymentDisclaimer: {
    marginTop: "32px",
    padding: "14px 28px",
    backgroundColor: kickLightBlue,
    alignSelf: "center",
  },
  paymentOrderAdditionalQuestion: {
    alignSelf: "center",
    marginTop: "-10px",
    marginBottom: "28px",
  },
  paymentShippingForm: {
    marginBottom: "40px",
  },
  paymentCardForm: {
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginTop: "20px",
    },
    [theme.breakpoints.up("md")]: {
      width: "75%",
      marginTop: "30px",
      marginLeft: "28px",
    },
  },
  paymentOrderConfirmation: {
    display: "flex",
    flexDirection: "column",
    marginTop: "22px",

    [theme.breakpoints.down("sm")]: { alignItems: "center" },

    [theme.breakpoints.up("md")]: {
      width: "75%",
      paddingLeft: "20px",
      paddingTop: "20px",
    },
  },
  label: {
    color: kickNavy,
    fontSize: "14px",
    marginBottom: "2px",
    marginTop: "4px",
    display: "block",
  },
  textField: {
    marginTop: "16px",
  },
  gridItemNoPadding: {
    [theme.breakpoints.down("sm")]: {
      padding: "0 !important",
    },
  },
  orderDetailsProductImage: {
    height: "60px",
  },
  subtitle: {
    fontSize: "24px",
    fontFamily: "Spectral-Bold",
    color: kickBlue,
    fontWeight: "bold",
  },
  checkoutProgressMobile: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      borderBottom: "1px solid #ddd",
      padding: "0 15px",
    },
  },
  checkoutProgressDesktop: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "20px",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  signupTrustbox: {
    marginBottom: "10px",
    left: "6px !important",
  },
  paymentCompleteCongrats: {
    width: "100%",
    maxWidth: VISIT_MAX_WIDTH,
    padding: "64px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    borderBottom: "1px solid #ddd",
    marginBottom: "16px",
    [theme.breakpoints.down("sm")]: {
      padding: "40px",
    },
  },
  priceOption: {
    display: "flex",
    justifyContent: "space-between",
    padding: "16px 8px",
    color: kickNavy,
  },
  upsellPriceOption: {
    display: "flex",
    justifyContent: "space-between",
    padding: "16px 8px",
    color: kickNavy,
    borderTop: "2px solid #e0e0e0",
    alignItems: "flex-start",
    marginTop: "10px",
  },
  priceTagLabel: {
    display: "flex",
    alignItems: "center",
    borderRadius: "10px",
    padding: "2px 8px",
    fontSize: "10px",
    fontWeight: "bold",
    margin: "4px 0 2px",
  },
  labelSubtext: {
    fontSize: "13px",
    color: kickRed,
    marginTop: "4px",
    fontWeight: "bold",
  },
  upgradeBtn: {
    fontSize: "14px",
    backgroundColor: "#ffa41c",
    color: kickNavy,
    display: "block",
    margin: "20px auto 16px",
    minWidth: "200px",
    textTransform: "unset",
  },
});

export default consultationStyle;
